import React from 'react';

import { useParams } from 'react-router';

import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { EditRemoveBtn } from 'components/buttons';
import { PanelGrid } from 'components/grid';
import { Block, OneColumn } from 'components/page';
import { usePermissionsContext } from 'context/PermissionsContext';
import { useGetColunasDinamicas } from 'pages/cadastro/colunas-dinamicas/hooks/useGetColunasDinamicas';
import { SecaoListColunasDinamicasFilter } from 'pages/cadastro/colunas-dinamicas/components';
import { ColunaDinamicaProps, GrupoExibicaoProps, Loja } from 'pages/cadastro/loja/types';

const gridRows = (rows: ColunaDinamicaProps[] | undefined): GridRowsProp => {
    if (!rows) return [];
    return rows.map((row, index) => {
        return { ...row, id: index + 1 };
    });
};

export function SecaoListColunasDinamicasComp() {
    const { data, refetch, isFetching } = useGetColunasDinamicas();
    const { hasPermission } = usePermissionsContext();

    const columns: GridColDef[] = [
        { field: 'idConfiguracaoPropriedade', headerName: 'ID', minWidth: 80 },
        { field: 'dsConfiguracao', headerName: 'Nome do campo', flex: 1, minWidth: 120 },
        { field: 'dsTipoConfiguracaoPropriedade', headerName: 'Tipo', flex: 1, minWidth: 120 },
        { field: 'nrSequencia', headerName: 'Ordem de exibição', minWidth: 80 },
    ];

    if (hasPermission(['LOJA_ALTERAR']) || hasPermission(['LOJA_EXCLUIR'])) {
        columns.push({
            field: 'acoes',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Ações',
            filterable: false,
            sortable: false,
            hideable: false,
            disableColumnMenu: true,
            width: 80,
            minWidth: 60,
            renderCell: (params) => (
                <EditRemoveBtn
                    id={params.row.idConfiguracaoPropriedade}
                    sx={{ ml: 'auto', p: 1.5 }}
                    showEditBtn={hasPermission(['LOJA_ALTERAR'])}
                    refresh={refetch}
                    showRemoveBtn={hasPermission(['LOJA_EXCLUIR'])}
                    removeUrl={`/gestao/configuracaopropriedade/${params.row.idConfiguracaoPropriedade}`}
                />
            ),
        });
    }

    return (
        <OneColumn title="Listagem de Colunas" createButton={hasPermission(['LOJA_CADASTRAR'])} goBackButton>
            <SecaoListColunasDinamicasFilter />

            <Block>
                <PanelGrid
                    rows={gridRows(data?.data)}
                    rowsCount={data?.total ?? 0}
                    reload={refetch}
                    loading={isFetching}
                    columns={columns}
                    visibleRows={10}
                />
            </Block>
        </OneColumn>
    );
}
